// extracted by mini-css-extract-plugin
export default {"formGroup":"ContactPage_formGroup__PvWJ2","error":"ContactPage_error__Az0KR","errorMessage":"ContactPage_errorMessage__S8vk4","submitButton":"ContactPage_submitButton__BvgdY"};